import { CustomerApplicationSubmission } from "@goodfill/domain-customer-application-types";
import { Button, Span } from "@goodfill/ui-components";
import { FC, useState } from "react";
import { useRecoilValue } from "recoil";
import { userCustomerApplicationState } from "../../../../state";
import { ApplicationExceptionsList } from "./ApplicationExceptionsList";
import { ApplicationPendingTasksList } from "./ApplicationPendingTasksList";

export const ApplicationStatusSection: FC = () => {
  const userCustomerApplicationData = useRecoilValue<CustomerApplicationSubmission | null>(
    userCustomerApplicationState,
  );
  const [showPending, setShowPending] = useState(false);

  if (userCustomerApplicationData === null) {
    return null;
  }

  const { submissionStatus, pendingTasks, exceptions } = userCustomerApplicationData;

  return (
    <div className="flex flex-col w-full my-1 md:my-2 mx-4 md:mx-8 px-4 md:px-8 gap-4 md:gap-8">
      <div className="flex flex-col items-start mx-2 md:mx-4">
        <Span font={"semibold"} size={"lg"}>
          Application Status:{" "}
          <Span
            font={"normal"}
            red={submissionStatus === "error"}
            green={submissionStatus === "accepted"}
            style={{
              textTransform: "uppercase",
            }}
          >
            {submissionStatus}
          </Span>
        </Span>
        <div className="flex my-1 md:my-2">
          <Button
            fill
            size={"small"}
            className="w-fit"
            primary={!showPending}
            onClick={() => setShowPending(false)}
            style={{
              marginRight: "1em",
            }}
          >
            Application Exceptions
          </Button>
          <Button fill size={"small"} className="w-fit" primary={showPending} onClick={() => setShowPending(true)}>
            Application Pending Tasks
          </Button>
        </div>
      </div>
      <div className="flex flex-col">
        {!showPending ? (
          <ApplicationExceptionsList exceptions={exceptions} />
        ) : (
          <ApplicationPendingTasksList tasks={pendingTasks} />
        )}
      </div>
    </div>
  );
};
